import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { postRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import messages from 'src/pages/TutorialDetailsPage/messages';
import { RequestSimplifiedData } from 'src/types/requestData';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

export type TutorialQuestionParamsType = {
  code: string;
  tutorialUuid: string;
  isVisible: boolean;
  questionEn: string;
  questionDe: string;
  descriptionEn: string;
  descriptionDe: string;
  correctAnswerExplanationEn: string;
  correctAnswerExplanationDe: string;
};

const createTutorialQuestion = async (
  tutorialQuestion: TutorialQuestionParamsType,
) => {
  const { data } = await postRequest<RequestSimplifiedData>(
    API.POST.tutorialQuestion,
    buildSaveTutorialQuestionParams(tutorialQuestion),
  );

  return data;
};

export const useCreateTutorialQuestion = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: createTutorialQuestion,
    onSuccess: () => {
      handleSuccess(formatMessage(messages.tutorialQuestionSaved), 1000);
      client.invalidateQueries({ queryKey: [QUERY_KEYS.TUTORIAL_QUESTIONS] });
    },
    onError: handleError,
  });
};

export function buildSaveTutorialQuestionParams(
  tutorialQuestion: TutorialQuestionParamsType,
) {
  return {
    tutorial_question: {
      code: tutorialQuestion.code,
      is_visible: tutorialQuestion.isVisible,
      question_en: tutorialQuestion.questionEn,
      question_de: tutorialQuestion.questionDe,
      tutorial_uuid: tutorialQuestion.tutorialUuid,
      description_en: tutorialQuestion.descriptionEn,
      description_de: tutorialQuestion.descriptionDe,
      explanation_en: tutorialQuestion.correctAnswerExplanationEn,
      explanation_de: tutorialQuestion.correctAnswerExplanationDe,
    },
  };
}
